'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onBackspace = exports.onTab = exports.onEnter = undefined;

var _onEnter = require('./onEnter');

var _onEnter2 = _interopRequireDefault(_onEnter);

var _onTab = require('./onTab');

var _onTab2 = _interopRequireDefault(_onTab);

var _onBackspace = require('./onBackspace');

var _onBackspace2 = _interopRequireDefault(_onBackspace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.onEnter = _onEnter2.default;
exports.onTab = _onTab2.default;
exports.onBackspace = _onBackspace2.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-edit-list/dist/handlers/index.js
// module id = 1110
// module chunks = 0